import { SET_HORECAS, HORECA_ERROR, SET_HORECA  } from "./actions";
export default function horeca(
  state = {
    error: {},
    items: [],
    item: [],
  },
  action = {}
) {
  switch (action.type) {
    case HORECA_ERROR:
      return { ...state, error: action.payload };
    case SET_HORECA:
      return { ...state, item: action.results };
    case SET_HORECAS:
      return { ...state, items: action.results };
    default:
      return state;
  }
}
